import React from 'react';
import {
  ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar,
} from 'recharts';
import CustomTooltip from './CustomTooltip';
import '../plots/plots.css';
import { colorForKey } from './colors';


export function SpeciesIdentifiedByLocationChart({ data }) {
  if (!data) return null;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data.rows} margin={{ top: 8, right: 16, left: 8, bottom: 0 }}>
        <CartesianGrid stroke="#e5e7eb" vertical={false} />
        <XAxis dataKey="Area" tickMargin={8} />
        <YAxis tickMargin={8} tickFormatter={(value) => value.toLocaleString()} />
        <Tooltip content={<CustomTooltip />} />
        <Legend verticalAlign="bottom" height={28} />
        {data.speciesKeys.map((key, index) => (
          <Bar key={key} dataKey={key} fill={colorForKey(key, index)} barSize={9} radius={[2,2,0,0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}

export function SpeciesIdentifiedByLocationTable({ data }) {
  if (!data) return null;

  // Helper to add thousand separators safely
  const formatNumber = (num) =>
    num !== null && num !== undefined ? num.toLocaleString('en-US') : '';

  return (
    <table className="anl-ttc-table anl-table">
      <thead>
        <tr>
          <th className="col-species">Area</th>
          {data.speciesKeys.map((sp) => <th key={sp}>{sp}</th>)}
          <th>Total (per Area)</th>
        </tr>
      </thead>
      <tbody>
        {data.rows.map((r) => (
          <tr key={r.Area}>
            <td className="col-species">{r.Area}</td>
            {data.speciesKeys.map((sp) => (
              <td key={sp} className="col-number">
                {formatNumber(r[sp])}
              </td>
            ))}
            <td className="col-number">
              {formatNumber(data.speciesKeys.reduce((s, sp) => s + (r[sp] || 0), 0))}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="anl-total-row">
          <td>Total (Monthly)</td>
          {data.speciesKeys.map((sp) => (
            <td key={sp} className="col-number">
              {formatNumber(data.totalsBySpecies[sp])}
            </td>
          ))}
          <td className="col-number">
            {formatNumber(data.totalsByArea.reduce((s, a) => s + a.total, 0))}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}